import { ZonedDateTime } from '@js-joda/core';
import { DEFAULT_DATE_FORMAT } from 'common/constant/constant';
import { parseISO as parseDate, format as formatDate } from 'date-fns';
import { switchToLocalTimezone } from 'utils/calendar/timezone-switch';

const DateTimeOffsetCell = ({ value }: { value: string }): JSX.Element => {
    if (!value) return <></>;

    const dateStringWithoutOffset = switchToLocalTimezone(value);
    const offset = ZonedDateTime.parse(value).offset().toString();

    return <>{`${formatDate(parseDate(dateStringWithoutOffset), DEFAULT_DATE_FORMAT)} (${offset})`}</>;
};

export default DateTimeOffsetCell;
